/** Matches `ProductCard` image section — keep editor preview WYSIWYG with dashboard/marketplace. */
export const PRODUCT_CARD_PREVIEW_IMAGE_HEIGHT = {
  desktop: 160,
  mobile: 120,
} as const;

/** Scheme-aware surface so create/edit preview matches cards in dark mode (CSS only). */
export const PRODUCT_CARD_PREVIEW_BG = 'var(--mantine-color-body)';

/**
 * Solid fill for canvas PNG capture / normalize.
 * Canvas 2D cannot resolve CSS variables — `var(--mantine-color-body)` becomes black.
 * Saved previews always use a white studio backdrop (matches the editor model-viewer).
 */
export const PRODUCT_PREVIEW_CAPTURE_BG = '#ffffff';

/** Square PNG size when saving from the model viewer (server thumbs scale down from full PNG). */
export const PRODUCT_PREVIEW_CAPTURE_SIZE = 480;

/** Gradient preview surface for upload / create cards (not listed product tiles). */
export function productCardPreviewBackground(
  accentColor: string,
  colorWithAlpha: (hex: string, alpha: number) => string
): string {
  return `linear-gradient(145deg, ${colorWithAlpha(accentColor, 0.06)} 0%, ${PRODUCT_CARD_PREVIEW_BG} 42%, ${colorWithAlpha(accentColor, 0.14)} 100%)`;
}
